import { useMutation, useQueryClient } from '@tanstack/react-query';

import { removeBackInStockWaitlistItem } from 'api/jalapeno';
import useAccountQuery from 'api/queries/useAccountQuery';
import { BACK_IN_STOCK_WAITLIST_ITEMS_QUERY_KEY } from 'api/queries/useBackInStockWaitlistItemsQuery';
import logError from 'utils/errorUtils';

const useRemoveBackInStockWaitlistItem = () => {
    const queryClient = useQueryClient();
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};

    return useMutation({
        mutationFn: async ({ requestID }) => {
            // apiFetchWithResponse swallows non-OK responses and resolves undefined
            const response = await removeBackInStockWaitlistItem({
                chargeID,
                sendParams: { requestID },
            });

            if (response?.msg !== 'Success') {
                throw new Error(response?.msg ?? 'Unable to remove item from the back-in-stock waitlist.');
            }

            return response;
        },
        onError: (error) => {
            logError(error);
            console.error(error);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [BACK_IN_STOCK_WAITLIST_ITEMS_QUERY_KEY, chargeID] });
        },
    });
};

export default useRemoveBackInStockWaitlistItem;
